export default "__VITE_ASSET__D_uorhoG__"